import React from 'react';
import PropTypes from 'prop-types';
import Link from "./Link";
import styled from 'styled-components'

const Navigation = styled.nav`
  border-bottom: 1px solid #333;
  padding: 16px 0;
  margin: 0 16px;
  text-align: center;
`;

const List = styled.ul`
  margin: 0;
  list-style: none;
  position: relative;
`;

const Menu = styled.ul`
  border: 2px solid #ccc;
  display: ${props => props.open ? 'block' : 'none'};
  position: absolute;
  margin-left: -32px;
  margin-top: 16px;
  background-color: white;
`;

const MenuItem = styled.li`
  display: block;
  text-align: left;
  padding: 8px 16px;
  &:hover {
    background-color: #ccc;
    color: white;
  }
`;

const ListItem = styled.li`
  padding: 8px;
  display: inline-block;

  @media all and (min-width: 1024px) {
    padding: 16px 24px;
  }
`;

class NavBar extends React.Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onToggleNav();
  }

  render() {
    return (
      <Navigation onClick={this.props.onCloseNav}>
        <List>
          <ListItem>
            <Link to="/">Home</Link>
          </ListItem>
          <ListItem>
            <Link to="/contact">Contact</Link>
          </ListItem>
          <ListItem>
            <Link to="/questions">Questions</Link>
          </ListItem>
          <ListItem>
            <Link to="/fees">Fees</Link>
          </ListItem>
          <ListItem>
            <Link onClick={this.toggle} to="/about">About</Link>
              <Menu open={this.props.aboutOpen}>
                  <MenuItem>
                    <Link to="/about/me">Me</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to="/about/initial-consultation">Initial Consultation</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to="/about/origins-of-chiropractic">Origins of Chiropractic</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to="/about/what-is-mctimoney">What is McTimoney?</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to="/about/privacy-notice">Privacy Notice</Link>
                  </MenuItem>
              </Menu>
          </ListItem>
          <ListItem>
            <Link to="/covid">COVID-19</Link>
          </ListItem>
        </List>
      </Navigation>
    );
  }
}

NavBar.propTypes = {
  aboutOpen: PropTypes.bool.isRequired,
  onToggleNav: PropTypes.func.isRequired,
  onCloseNav: PropTypes.func.isRequired,
};

export default NavBar;




// WEBPACK FOOTER //
// ./src/components/NavBar.js